module.exports = __webpack_public_path__ + "static/pr-op-planning@2x-8a2871a222ab9ff2254bdabce20e84e5.png";